export const TYPE2CLASS = {
  'Ping'               : 'icon-ping',
  'Keyboard'           : 'icon-keyboard',
  'Run'                : 'icon-publish',
  'Exit'               : 'icon-cancel',
  'Activity'           : 'icon-reload',
  'Screenshot'         : 'icon-picture',
  'WebcamSnapshot'     : 'icon-camera',
  'NetworkConnection'  : 'icon-network',
  'AppInstallation'    : 'icon-install',
  'Web'                : 'icon-globe',
  'Im'                 : 'icon-dialog',
  'Mail'               : 'icon-mail',
  'Message'            : 'icon-dialog',
  'FTP'                : 'icon-folder',
  'PrintDoc'           : 'icon-print',
  'UserLogon'          : 'icon-login',
  'Clipboard'          : 'icon-clipboard',
  'Device'             : 'icon-device',
  'DiskDrive'          : 'icon-hdd',
  'FileOperation'      : 'icon-file',
  'UserLoggedOn'       : 'icon-login',
  'UserLoggedOff'      : 'icon-logout',
  'UserSessionLocked'  : 'icon-logout',
  'UserSessionUnlocked': 'icon-login',
  'Install'            : 'icon-install',
  'Deinstall'          : 'icon-trash',
  'SystemLog'          : 'icon-temperatire',
  'InterceptedFile'    : 'icon-attach',
  'Stat'               : 'icon-ok-circled',
  'UserTorturer'       : 'icon-money',
  'MicRecording'       : 'icon-mic',
  'DevInventory'       : 'icon-device',
  'AppInventory'       : 'icon-install',
  'UserActivity'       : 'icon-bell',
  'WebSearch'          : 'icon-search',
  'DesktopVideo'       : 'icon-video',
  'FormData'           : 'icon-wpforms',
  'WLan'               : 'icon-wifi',
  'TTY'                : 'icon-desktop',
};

export const DIM2CLASS = {
  'agent_eventtype'        : 'icon-right-hand',
  'agent_agent'            : 'icon-laptop',
  'agent_account'          : 'icon-user',
  'agent_application'      : 'icon-window',
  'agent_web'              : 'icon-globe',
  'agent_networkconnection': 'icon-network',
  'agent_attachedfile'     : 'icon-docs',
  'agent_fileoperationtype': 'icon-floppy',
  'agent_dialog'           : 'icon-dialog',
  'agent_time'             : 'icon-calendar',
  'agent_appinstallation'  : 'icon-install',
  'agent_device'           : 'icon-device',
  'analytics_filter'       : 'icon-lightbulb',
  'agent_feedbacktype'     : 'icon-bell',
  'analytics_tag'          : 'icon-tag',
};



// WEBPACK FOOTER //
// ./src/core/icon-class.js